import { Outlet } from "react-router-dom";
import AuthComponent from "../pages/authpage/AuthComponent.jsx";
import UserOtp from "../pages/authpage/Otp.jsx";
import ForgetPassword from "../pages/authpage/ForgetPassword.jsx";
import PasswordOtp from "../pages/authpage/PasswordOtp.jsx";
import ResetPassword from "../pages/authpage/ResetPassword.jsx";
import Maintenance from "../pages/maintenance/Maintenance.jsx";
import Dashboard from "../pages/user/dashboard/Dashboard.jsx";
import Accounts from "../pages/user/accounts/Accounts.jsx";
import AccountTypes from "../pages/user/accounts/components/AccountTypes.jsx";
import Deposit3 from "../pages/user/wallet/deposit/Deposit3.jsx";
import Withdraw3 from "../pages/user/wallet/withdraw/Withdraw3.jsx";
import Transfer2 from "../pages/user/transfer/Transfer2.jsx";
// import DepositUSDT from "../pages/user/wallet/deposit/components/DepositUSDT.jsx";
// import parentTree from "../pages/user/ParentTree/ParentTree.jsx"
import MyTransactions from "../pages/user/transactions/Transactions.jsx";
import Tutorials from "../pages/user/tutorials/Tutorials.jsx";
import Support from "../pages/user/support/Support.jsx";
import ViewTicket from "../pages/user/support/components/ViewTicket.jsx";
import Faq from "../pages/user/faq/Faq.jsx";
import Kyc from "../pages/user/kyc/Kyc.jsx";
import IBDashboard from "../pages/ib/ibDashboard/IBDashboard.jsx";
import IBDashboardMobile from "../pages/ib/ibDashboard/IBDashboardMobile.jsx";
import IBSettingsMobile from "../pages/ib/settings/IBSettingsMobile.jsx";
import IBWithdraw from "../pages/ib/wallet/withdraw/Withdraw.jsx";
import IBWithdrawMobile from "../pages/ib/wallet/withdraw/IBWithdrawMobile.jsx";
import IBTeam from "../pages/ib/ibTeam/IBTeam.jsx";
import IBTeamMobile from "../pages/ib/ibTeam/IBTeamMobile.jsx";
import Transactions from "../pages/ib/transactions/Transactions.jsx";
import IBTree from "../pages/ib/ibTree/IBTree.jsx";
import Trade from "../pages/ib/report/trade/Trade.jsx";
import Earning from "../pages/ib/report/earning/Earning.jsx";
import IBSupport from "../pages/ib/support/Support.jsx";
import PageNotFound from "../pages/pageNotFound/PageNotFound.jsx";
import EmailExpired from "../pages/emailExpired/EmailExpired.jsx";
import TermsAndCondition from "../pages/termsAndCondition/TermsAndCondition.jsx";
import ViewIBTicket from "../pages/ib/support/components/ViewIBTicket.jsx";
import LiveAccount from "../pages/ib/liveAccount/LiveAccount.jsx";
import LiveAccountMobile from "../pages/ib/liveAccount/LiveAccountMobile.jsx";
import Commission from "../pages/ib/commission/Commission";
import CommissionMobile from "../pages/ib/commission/CommissionMobile.jsx";
import KYCManager from "../pages/ib/kycManager/KYCManager.jsx";
import KYCManagerMobile from "../pages/ib/kycManager/KYCManagerMobile.jsx";
import IBManager from "../pages/ib/iBManager/IBManager.jsx";
import IBManagerMobile from "../pages/ib/iBManager/IBManagerMobile.jsx";
import Inbox from "../pages/user/inbox/Inbox.jsx"
import IBInbox from "../pages/ib/inbox/Inbox.jsx"
import CommissionDistribute from "../pages/ib/commissionDistribute/CommissionDistribute.jsx";
import IbDetails from "../pages/ib/iBManager/components/IbDetails.jsx";
import Promotion from "../pages/ib/promotion/promotion.jsx"
import PromotionMobile from "../pages/ib/promotion/PromotionMobile.jsx"
import Promotionview from "../pages/ib/promotion/promotionview.js"
import Logs from "../pages/user/logs/logs.jsx"
import PerfectMoney from "../pages/user/payment/PerfectMoney.jsx";
import Payment from "../pages/user/payment/payment.jsx"
import AdminLogin from "../pages/authpage/AdminLogin.jsx";
import Download from "../pages/user/download/Download.jsx";
import WithdrawalReport from "../pages/user/Reports/withdrawalReport.jsx"
import TransferReport from "../pages/user/Reports/transferReport.jsx"
import DepositReport from "../pages/user/Reports/depositReport.jsx";
import accountVerify from "../pages/user/accountVerify/accountVerify.jsx"
import PaymentVerify from "../pages/user/wallet/PaymentVerify.jsx";
import Leaderboard from "../pages/user/LeaderBoard/LeaderBoard.jsx";
import LeaderboardMobile from "../pages/user/LeaderBoard/LeaderBoardMobile.jsx";
import SettingsMobile from "../pages/user/settings/SettingsMobile.jsx";
import UserProfile from "../pages/user/profile/UserProfile.jsx";
import ProfileMobile from "../pages/user/profile/ProfileMobile.jsx";
import ChangePasswordMobile from "../pages/user/profile/ChangePasswordMobile.jsx";
import MobileDashboard from "../pages/user/dashboard/MobileDashboard.jsx";
import MobileAccountTypes from "../pages/user/accounts/MobileAccountTypes.jsx";
import WalletPage from "../pages/user/wallet/WalletPage.jsx";
import TransferMobile from "../pages/user/transfer/TransferMobile.jsx";

const IbRoutes = [
  { path: "/ib", type: "private", component: IBDashboard, mobileComponent: IBDashboardMobile, ib: "ib", title: "IB Dashboard" },
  { path: "dashboard", type: "private", component: IBDashboard, mobileComponent: IBDashboardMobile, ib: "ib", title: "IB Dashboard" },
  { path: "settings", type: "private", component: IBSettingsMobile, mobileComponent: IBSettingsMobile, ib: "ib", title: "IB Settings" },
  { path: "live_account", type: "private", component: LiveAccount, mobileComponent: LiveAccountMobile, ib: "ib", title: "Live Account" },
  { path: "kyc_manager", type: "private", component: KYCManager, mobileComponent: KYCManagerMobile, ib: "ib", title: "KYC Manager" },
  { path: "ib_manager", type: "private", component: IBManager, mobileComponent: IBManagerMobile, ib: "ib", title: "IB Manager" },
  { path: "ib_details/:id", type: "private", component: IbDetails, ib: "ib", title: "IB Details", parent: [{ title: 'IB Manager', path: '/ib/ib_manager?filter=Approved' }] },
  { path: "withdraw", type: "private", component: IBWithdraw, mobileComponent: IBWithdrawMobile, ib: "ib", title: "IB Withdraw" },
  { path: "my_trader_team", type: "private", component: IBTeam, mobileComponent: IBTeamMobile, ib: "ib", title: "My Trader Team" },
  { path: "commission", type: "private", component: Commission, mobileComponent: CommissionMobile, ib: "ib", title: "IB Commission" },
  { path: "transactions", type: "private", component: Transactions, ib: "ib", title: "Transactions" },
  { path: "tree", type: "private", component: IBTree, ib: "ib", title: "IB Tree" },
  { path: "trade_sub_report", type: "private", component: Trade, ib: "ib", title: "Trade Report" },
  { path: "my_earning_report", type: "private", component: Earning, ib: "ib", title: "My Earning Report" },
  { path: "support", type: "private", component: IBSupport, ib: "ib", title: "IB Support" },
  { path: "inbox", type: "private", component: IBInbox, ib: "ib", title: "IB Inbox" },
  { path: "commission_distribute", type: "private", component: CommissionDistribute, ib: "ib", title: "Commission Distribution" },
  { path: "promotion", type: "private", component: Promotion, mobileComponent: PromotionMobile, ib: "ib", title: "Promotion" },
  { path: "view_ticket/:ticketId", type: "private", component: ViewIBTicket, ib: "ib", title: "IB Support Ticket" },
];

const routes = [
  // ============ Auth ===============
  { path: "/", type: "auth", component: AuthComponent },
  { path: "otp", type: "auth", component: UserOtp },
  { path: "forget_password", type: "auth", component: ForgetPassword },
  { path: "password_otp_verification", type: "auth", component: PasswordOtp },
  { path: "reset_password", type: "auth", component: ResetPassword },

  // ============ Public =============
  { path: "maintenance", type: "public", component: Maintenance },
  { path: "promotionkit/:kitId", type: "public", component: Promotionview },
  { path: "emailexpired", type: "public", component: EmailExpired },
  { path: "*", type: "public", component: PageNotFound },
  { path: "/adminlogin", type: "public", component: AdminLogin },
  { path: "terms_&_conditions", type: "public", component: TermsAndCondition, title: "Terms & Conditions" },
  { path: "perfectMoney", type: "public", component: PerfectMoney },
  { path: "payment/:id", type: "public", component: Payment },

  // ============ Private ==============
  { isProfileCompleted: true, path: "dashboard", type: "kyc", component: Dashboard, mobileComponent: MobileDashboard, title: "Dashboard", },
  { isProfileCompleted: true, path: "client_profile", type: "private", component: accountVerify, title: "Client Profile" },
  { isProfileCompleted: true, path: "accounts", type: "private", component: Accounts, title: "Accounts" },
  { isProfileCompleted: true, path: "account", type: "private", component: AccountTypes, mobileComponent: MobileAccountTypes, title: "Account Types", parent: [{ title: 'Accounts', path: '/accounts' }] },
  { isProfileCompleted: true, path: "wallet", type: "private", component: WalletPage, mobileComponent: WalletPage, title: "Wallet" },
  { isProfileCompleted: true, path: "deposit", type: "private", component: Deposit3, mobileComponent: WalletPage, title: "Deposit" },
  { isProfileCompleted: true, path: "withdraw", type: "private", component: Withdraw3, mobileComponent: WalletPage, title: "Withdraw" },
  { isProfileCompleted: true, path: "inbox", type: "private", component: Inbox, title: "Inbox" },
  // { isProfileCompleted: true, path: "deposit_usdt/:id", type: "private", component: DepositUSDT, title: "Deposit USDT", parent: [{ title: 'Deposit', path: '/deposit' }] },
  // { isProfileCompleted: true, path: "perent_tree", type: "private", component: parentTree, title: "Perent Tree" },
  { isProfileCompleted: true, path: "transfer", type: "private", component: Transfer2, mobileComponent: TransferMobile, title: "Internal Transfer" },
  { isProfileCompleted: true, path: "my_transaction", type: "private", component: MyTransactions, title: "My Transaction", },
  { isProfileCompleted: true, path: "logs", type: "private", component: Logs, title: "Logs" },
  { isProfileCompleted: true, path: "withdrawal_Report", type: "private", component: WithdrawalReport, title: "Withdrawal Report" },
  { isProfileCompleted: true, path: "transfer_Report", type: "private", component: TransferReport, title: "Internal Transfer Report" },
  { isProfileCompleted: true, path: "deposit_Report", type: "private", component: DepositReport, title: "Deposit Report" },
  { isProfileCompleted: true, path: "payment_verify/:CRM_OrderId", type: "private", component: PaymentVerify, title: "Payment Verify" },
  { isProfileCompleted: true,path: "leaderboard", type: "private", component: Leaderboard, mobileComponent: LeaderboardMobile, title: "LeaderBoard" },

  // ============ KYC ==============
  { path: "tutorials", type: "kyc", component: Tutorials, title: "Tutorials" },
  { path: "support", type: "kyc", component: Support, title: "Support" },
  { path: "view_ticket/:ticketId", type: "kyc", component: ViewTicket, title: "Support Ticket", parent: [{ title: 'Support', path: '/support' }] },
  { path: "faq", type: "kyc", component: Faq, title: "Faq" },
  { path: "download", type: "kyc", component: Download, title: "Download Application" },
  { path: "kyc", type: "kyc", component: Kyc, mobileComponent: Kyc, title: "KYC" },

  // ============ IB ==============
  { path: "ib", type: "private", component: Outlet, children: IbRoutes, ib: "parent", },

  { path: "settings", type: "private", component: SettingsMobile, mobileComponent: SettingsMobile, title: "Setting" },
  { path: "profile", type: "private", component: UserProfile, mobileComponent: ProfileMobile, title: "Profile", },
  { path: "change_password", type: "private", component: ChangePasswordMobile, mobileComponent: ChangePasswordMobile, title: "Change Password" },
];

export default routes;